import React from "react";
const Notulensi = React.lazy(() => import('./Notulensi'));

export const notulensiConfigs = [
    {
        path: '/apps/notulensi',
        element: <Notulensi />,
        // permittedRole: ['pegawai'],
        roleAccess: ['NOTULENSI_USER']
    },
    {
        path: '/apps/notulensi/dokumen/tambah',
        element: <Notulensi />,
        // permittedRole: ['pegawai'],
        roleAccess: ['NOTULENSI_KONSEPTOR']
    },
    {
        path: '/apps/notulensi/:type',
        element: <Notulensi />,
        // permittedRole: ['pegawai'],
        roleAccess: ['NOTULENSI_USER']
    },
    {
        path: '/apps/notulensi/:type/:filter',
        element: <Notulensi />,
        // permittedRole: ['pegawai'],
        roleAccess: ['NOTULENSI_USER']
    },
    {
        path: '/apps/notulensi/:type/detail/:id',
        element: <Notulensi />,
        // permittedRole: ['pegawai'],
        roleAccess: ['NOTULENSI_USER']
    },
    {
        path: '/apps/notulensi/:type/detail/:id/:filter',
        element: <Notulensi />,
        // permittedRole: ['pegawai'],
        roleAccess: ['NOTULENSI_USER']
    },
    {
        path: '/apps/notulensi/:type/edit/:id',
        element: <Notulensi />,
        // permittedRole: ['pegawai'],
        roleAccess: ['NOTULENSI_USER', 'NOTULENSI_KONSEPTOR']
    },
    {
        path: '/apps/notulensi/:type/edit/:id/:filter',
        element: <Notulensi />,
        // permittedRole: ['pegawai'],
        roleAccess: ['NOTULENSI_USER', 'NOTULENSI_KONSEPTOR']
    },
];